"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackProvider = exports.useFeedback = void 0;
var feedback_context_1 = require("./feedback-context");
Object.defineProperty(exports, "useFeedback", { enumerable: true, get: function () { return feedback_context_1.useFeedback; } });
Object.defineProperty(exports, "FeedbackProvider", { enumerable: true, get: function () { return feedback_context_1.FeedbackProvider; } });
